import { useQuery } from "@tanstack/react-query";
import { useParams, useSearchParams } from "react-router-dom";
import Container from "../components/ui/Container/Container";
import { QueryKey } from "../services/query-keys";
import IUser from "../shared/IUser";
import ErrorsAlert from "../components/ErrorsAlert/ErrorsAlert";
import { ErrorResponse } from "../custom-fetch";
import Spinner from "../components/ui/Spinner/Spinner";
import UserEdit from "../components/Users/UserEdit";
import { useUserService } from "../services/users-service";
import PageHeading from "../components/ui/PageHeading/PageHeading";
import { Route } from "../routes";

type Params = {
  id: string;
};

const UserPage: React.FC = () => {
  const { id } = useParams<Params>();
  const [searchParams] = useSearchParams();
  const organizationId = searchParams.get("organizationId");
  const { getUser } = useUserService();
  
  const {
    data: user,
    isLoading,
    isError,
    error,
  } = useQuery<IUser, ErrorResponse>({
    queryKey: [QueryKey.users, id],
    queryFn: ({ signal }) => getUser({ signal, id: id! }),
    enabled: id !== 'add',
  });

  return (
    <>
      <PageHeading backTo={organizationId ? Route.organization(organizationId) : user?.organizationId ? Route.organization(user.organizationId) : Route.organizations}>{id === 'add' ? 'Add User' : 'Edit User'}</PageHeading>
      <Container>
        {isError && error ? (
          <ErrorsAlert errors={error.messages} />
        ) : isLoading && id !== 'add' ? (
          <Spinner />
        ) : (
          <UserEdit id={id!} user={user} organizationId={organizationId || undefined} />
        )}
      </Container>
    </>
  );
};

export default UserPage;
